import { mapPresentationDefaults } from './presentation'

// 两个入口只提供独立的初始样式，继续使用 map 渲染器及同一设备位置协议。
export function createLocalMapPreset (kind) {
  if (!['series', 'province'].includes(kind)) throw new Error('不支持的本地地图预设')
  const province = kind === 'province'
  const label = province ? '各省分布情况地图' : '系列分布地图'
  return {
    label,
    description: province ? '省级边界与设备位置，可切换区域数量统计' : '全国轮廓与设备点位，可切换区域数量统计',
    cover: 'ui/component-map-' + kind + '.svg',
    option: {
      name: label, title: label, icon: 'icon-map', dataType: 5,
      parameter: { scope: 'all', productIds: [], deviceIds: [], state: 'all' },
      data: [], dataFormatter: '', dataScript: '',
      component: { width: 800, height: 500, name: 'map', prop: 'map' },
      option: {
        type: 0, regionCode: '100000', mapLevel: province ? 'province' : 'country',
        ...mapPresentationDefaults, zoom: 1, scale: 87,
        color: '#a9d5e4', empColor: '#fff', fontSize: 12,
        backgroundColor: 'transparent', roam: true, allowPan: true, allowZoom: true, displayMode: 'devices', regionCountLevel: 'province',
        clusterPoints: true,
        banner: false, bannerTime: 3000
      }
    }
  }
}
